module.exports = __webpack_public_path__ + "img/press-cover.99b1e944.jpg";